import { useState } from "react";
import { Drawer, Button, Flex, Typography } from "antd";
import { HarvestConstraints } from "./HarvestConstraints";

const { Title } = Typography;

export function HarvestSetup({ open, onOpen }) {
  const [showSetup, setShowSetup] = useState(false);
  const isOpen = open !== undefined ? open : showSetup;
  const handleClose = () => {
    setShowSetup(false);
    onOpen?.(false);
  };

  return (
    <Drawer
      title={
        <Title level={4} type="danger" style={{ margin: 0 }}>
          Harvest Setup
        </Title>
      }
      placement="right"
      mask={false}
      destroyOnHidden={false}
      getContainer={false}
      onClose={handleClose}
      open={isOpen}
      footer={
        <Flex vertical gap="large" align="stretch">
          <Button color="primary" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
        </Flex>
      }
    >
      <HarvestConstraints onClose={handleClose} />
    </Drawer>
  );
}
